import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import MaterialTable from "@material-table/core";
import { ExportCsv } from "@material-table/exporters";

/*Import API helpers */
import { fetchGET, fetchPUT, fetchPOST, fetchDELETE } from "../apiHelper";
import {
  sifrantARRS,
  sifrantKlasius,
  sifrantCerif,
  claniceV2,
  putClaniceV2,
  koristniLinki,
} from "../listOfApi";

/*React-Bootstrap components */
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";

/*React icons */
import { BsListOl } from "react-icons/bs";

import RoleGuard from "../auth/RoleGuard";
import { MODULES, ROLE_GROUPS } from "../auth/roles";
import AccessDenied from "./ui/AccessDenied";

const CodeList = () => {
  const [sifrantTitle, setSifrantTitle] = useState("ARIS");
  const [modalNaziv, setModalNaziv] = useState("");
  const [modalKontakt, setModalKontakt] = useState("");
  const [modalLinkId, setModalLinkId] = useState("");
  const [modalLinkNaziv, setModalLinkNaziv] = useState("");
  const [modalLinkLink, setModalLinkLink] = useState("");
  const [saveKontakt, setSaveKontakt] = useState("");
  const [sifrantList, setSifrantList] = useState([]);
  const [columnsList, setColumnsList] = useState([]);
  const [showModal1, setShowModal1] = useState(false);
  const [showModal2, setShowModal2] = useState(false);
  const [showModal3, setShowModal3] = useState(false);
  const [addNaziv, setAddNaziv] = useState();
  const [addLink, setAddLink] = useState();

  const history = useNavigate();

  const columns = [
    {
      title: "Naziv",
      field: "naziv",
    },
  ];

  const columnsClanice = [
    {
      title: "Naziv",
      field: "naziv",
      width: null,
      cellStyle: { width: 100 },
    },
    {
      title: "Kontakt",
      field: "kontakt",
      width: null,
      cellStyle: { width: 800 },
    },
  ];

  const columnsPovezave = [
    {
      title: "Naziv",
      field: "naziv",
    },
    {
      title: "Povezava",
      field: "link",
    },
  ];

  useEffect(() => {
    fetchGET(sifrantARRS).then((sifrant) => {
      if (sifrant !== 0) {
        setSifrantList(sifrant);
        setColumnsList(columns);
      } else {
      }
    });
  }, []);

  const handleChangeARRS = () => {
    fetchGET(sifrantARRS).then((sifrant) => {
      if (sifrant !== 0) {
        setSifrantList(sifrant);
        setSifrantTitle("ARIS");
        setColumnsList(columns);
      }
    });
  };

  const handleChangeCerif = () => {
    fetchGET(sifrantCerif).then((sifrant) => {
      if (sifrant !== 0) {
        setSifrantList(sifrant);
        setSifrantTitle("CERIF");
        setColumnsList(columns);
      }
    });
  };

  const handleChangeKlasius = () => {
    fetchGET(sifrantKlasius).then((sifrant) => {
      if (sifrant !== 0) {
        setSifrantList(sifrant);
        setSifrantTitle("KLASIUS");
        setColumnsList(columns);
      }
    });
  };

  const handleChangeClanice = () => {
    fetchGET(claniceV2).then((sifrant) => {
      if (sifrant !== 0) {
        setSifrantList(sifrant);
        setSifrantTitle("ČLANICE");
        setColumnsList(columnsClanice);
      }
    });
  };

  const handleChangePovezave = () => {
    fetchGET(koristniLinki).then((sifrant) => {
      if (sifrant !== 0) {
        setSifrantList(sifrant);
        setSifrantTitle("KORISTNE POVEZAVE");
        setColumnsList(columnsPovezave);
      }
    });
  };

  const handleRowClick = (naziv, kontakt) => {
    setShowModal1(true);
    setModalNaziv(naziv);
    setModalKontakt(kontakt);
    setSaveKontakt(kontakt);
  };

  const handleSaveKontakt = () => {
    fetchPUT(putClaniceV2, { naziv: modalNaziv, kontakt: saveKontakt }).then(
      (projekti) => {
        if (projekti === 1) {
          handleChangeClanice();
          setShowModal1(false);
        } else {
          setShowModal1(false);
        }
      },
    );
  };

  const handleSaveLink = () => {
    fetchPOST(koristniLinki, { naziv: addNaziv, link: addLink }).then(
      (projekti) => {
        if (projekti === 1) {
          handleChangePovezave();
          setShowModal2(false);
        } else {
          setShowModal2(false);
        }
      },
    );
  };

  const handleDeletelink = (id) => {
    fetchDELETE(`${koristniLinki}/${id}`).then((deleted) => {
      if (deleted === 1) {
        handleChangePovezave();
      }
    });
  };

  const handleUpdatelink = () => {
    fetchPUT(koristniLinki, {
      id: modalLinkId,
      naziv: modalLinkNaziv,
      link: modalLinkLink,
    }).then((projekti) => {
      if (projekti === 1) {
        handleChangePovezave();
        setShowModal3(false);
      } else {
        setShowModal3(false);
      }
    });
  };

  return (
    <RoleGuard
      moduleKey={MODULES.SIFRANTI}
      roles={ROLE_GROUPS.GLOBALNI}
      fallback={<AccessDenied />}
    >
      <Container fluid>
        <Row>
          <Col className="main-header font-weight-bold">
            <BsListOl className="me-2" />
            Šifranti
          </Col>
        </Row>
        <Row>
          <Col className="header-divider">
            <hr />
          </Col>
        </Row>
        <Row>
          <Col>
            <Button
              variant="outline-primary border-0"
              onClick={handleChangeARRS}
            >
              Šifranti ARIS
            </Button>{" "}
            {"|"}
            <Button
              variant="outline-primary border-0"
              onClick={handleChangeCerif}
            >
              Šifranti Cerif
            </Button>{" "}
            {"|"}
            <Button
              variant="outline-primary border-0"
              onClick={handleChangeKlasius}
            >
              Šifranti Klasius
            </Button>{" "}
            {"|"}
            <Button
              variant="outline-primary border-0"
              onClick={handleChangeClanice}
            >
              Šifrant članic
            </Button>
            {"|"}
            <Button
              variant="outline-primary border-0"
              onClick={handleChangePovezave}
            >
              Šifrant koristnih povezav
            </Button>
          </Col>
        </Row>
        <Row className="mt-3">
          <Col>
            <h4>{sifrantTitle}</h4>
          </Col>
          {sifrantTitle === "KORISTNE POVEZAVE" ? (
            <Col lg="auto">
              <Button
                variant="outline-danger btn-sm"
                onClick={() => {
                  setShowModal2(true);
                }}
              >
                Dodaj povezavo
              </Button>
            </Col>
          ) : (
            ""
          )}
        </Row>
        <Row className="mt-4">
          <Col>
            <MaterialTable
              title={""}
              columns={columnsList}
              data={sifrantList}
              localization={{
                toolbar: {
                  searchPlaceholder: "Iskalnik",
                  exportCSVName: "Izvozi podatke v CSV",
                },
                header: { actions: "" },
                body: {
                  emptyDataSourceMessage: "Ni zapisov za prikaz",
                },
              }}
              options={{
                headerStyle: { fontWeight: "bold" },
                paging: false,
                searchFieldAlignment: "left",
                actionsColumnIndex: -1,
                exportMenu: [
                  {
                    label: "Izvozi podatke v CSV",
                    exportFunc: (cols, datas) =>
                      ExportCsv(
                        cols,
                        datas,
                        sifrantTitle === "ARIS"
                          ? `sifrant_aris_${new Date().toLocaleDateString("sl-SI").replace(/\. /g, "-")}`
                          : sifrantTitle === "CERIF"
                            ? `sifrant_cerif_${new Date().toLocaleDateString("sl-SI").replace(/\. /g, "-")}`
                            : sifrantTitle === "KLASIUS"
                              ? `sifrant_klasius_${new Date().toLocaleDateString("sl-SI").replace(/\. /g, "-")}`
                              : sifrantTitle === "ČLANICE"
                                ? `sifrant_clanice_${new Date().toLocaleDateString("sl-SI").replace(/\. /g, "-")}`
                                : `sifrant_koristnih_povezav_${new Date().toLocaleDateString("sl-SI").replace(/\. /g, "-")}`,
                      ),
                  },
                ],
              }}
              actions={
                sifrantTitle === "ČLANICE"
                  ? [
                      (rowData) => ({
                        icon: "edit",
                        tooltip: "Uredi " + rowData.naziv,
                        onClick: (event, rowData) => {
                          handleRowClick(rowData.naziv, rowData.kontakt);
                        },
                      }),
                    ]
                  : sifrantTitle === "KORISTNE POVEZAVE"
                    ? [
                        {
                          icon: "edit",
                          tooltip: "Uredi",
                          onClick: (event, rowData) => {
                            setShowModal3(true);
                            setModalLinkId(rowData.id);
                            setModalLinkNaziv(rowData.naziv);
                            setModalLinkLink(rowData.link);
                          },
                        },
                        {
                          icon: "delete",
                          tooltip: "Izbriši",
                          iconProps: { color: "error" },
                          onClick: (event, rowData) => {
                            handleDeletelink(rowData.id);
                          },
                        },
                      ]
                    : []
              }
            />
          </Col>
        </Row>
        {/* MODAL EDIT ČLANICA */}
        <Modal
          show={showModal1}
          onHide={() => {
            setShowModal1(false);
          }}
          centered
        >
          <Modal.Body>
            <Row>
              <Col style={{ fontWeight: "600", margin: "10px 10px 30px" }}>
                Sprememba kontakta za {modalNaziv}
              </Col>
            </Row>
            <Form.Control
              name="nazivSlo"
              type="text"
              required
              defaultValue={modalKontakt}
              onChange={(e) => {
                setSaveKontakt(e.target.value);
              }}
            />
            <Row style={{ marginTop: "2em" }}>
              <Col style={{ textAlign: "right" }}>
                <Button
                  style={{ marginRight: "5px" }}
                  className="btn btn-danger btn-sm"
                  variant="secondary"
                  onClick={() => {
                    handleSaveKontakt();
                  }}
                >
                  Shrani
                </Button>
                <Button
                  variant="primary btn-sm"
                  onClick={() => {
                    setShowModal1(false);
                  }}
                >
                  Prekliči
                </Button>
              </Col>
            </Row>
          </Modal.Body>
        </Modal>
        {/* MODAL ADD LINK */}
        <Modal
          show={showModal2}
          onHide={() => {
            setShowModal2(false);
          }}
          centered
        >
          <Modal.Body>
            <Row>
              <Col style={{ fontWeight: "600", margin: "10px 10px 30px" }}>
                Dodajanje nove povezave
              </Col>
            </Row>
            <Form.Control
              name="nazivSlo"
              type="text"
              required
              placeholder="Vpiši naziv..."
              onChange={(e) => {
                setAddNaziv(e.target.value);
              }}
              style={{ marginBottom: "10px" }}
            />
            <Form.Control
              name="nazivSlo"
              as="textarea"
              rows={3}
              required
              placeholder="Prilepi povezavo..."
              onChange={(e) => {
                setAddLink(e.target.value);
              }}
            />
            <br />
            <br />
            <Col style={{ textAlign: "right" }}>
              <Button
                className="btn btn-danger btn-sm"
                variant="secondary"
                onClick={() => {
                  handleSaveLink();
                }}
              >
                Dodaj
              </Button>
              &nbsp;&nbsp;
              <Button
                variant="primary btn-sm"
                onClick={() => {
                  setShowModal2(false);
                }}
              >
                Prekliči
              </Button>
            </Col>
          </Modal.Body>
        </Modal>
        {/* MODAL ADD LINK */}
        <Modal
          show={showModal3}
          onHide={() => {
            setShowModal3(false);
          }}
          centered
        >
          <Modal.Body>
            <Row>
              <Col style={{ fontWeight: "600", margin: "10px 10px 30px" }}>
                Urejanje povezave
              </Col>
            </Row>
            <Form.Control
              name="nazivSlo"
              type="text"
              required
              defaultValue={modalLinkNaziv}
              placeholder="Vpiši naziv..."
              onChange={(e) => {
                setModalLinkNaziv(e.target.value);
              }}
              style={{ marginBottom: "10px" }}
            />
            <Form.Control
              name="nazivSlo"
              as="textarea"
              rows={3}
              required
              defaultValue={modalLinkLink}
              placeholder="Prilepi povezavo..."
              onChange={(e) => {
                setModalLinkLink(e.target.value);
              }}
            />
            <br />
            <br />
            <Col style={{ textAlign: "right" }}>
              <Button
                className="btn btn-danger btn-sm"
                variant="secondary"
                onClick={() => {
                  handleUpdatelink();
                }}
              >
                Shrani
              </Button>
              &nbsp;&nbsp;
              <Button
                variant="primary btn-sm"
                onClick={() => {
                  setShowModal3(false);
                }}
              >
                Prekliči
              </Button>
            </Col>
          </Modal.Body>
        </Modal>
      </Container>
    </RoleGuard>
  );
};

export default CodeList;
